import { useState, useEffect } from 'react'
import { apiClient } from '../api/client'
import type { AlbumPhoto } from '../api/types'

type UseAlbumPhotosResult = {
  photos: AlbumPhoto[]
  loading: boolean
  error: string | null
  refresh: () => void
}

/**
 * アルバムの写真一覧を取得するカスタムフック
 */
export function useAlbumPhotos(albumId: string | null): UseAlbumPhotosResult {
  const [photos, setPhotos] = useState<AlbumPhoto[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchAlbumPhotos = async () => {
    if (!albumId) {
      setPhotos([])
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const response = await apiClient.getAlbumPhotos(albumId)
      setPhotos(response.photos)
    } catch (err) {
      console.error('Failed to fetch album photos:', err)
      setError(err instanceof Error ? err.message : 'Failed to fetch album photos')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAlbumPhotos()
  }, [albumId])

  return {
    photos,
    loading,
    error,
    refresh: fetchAlbumPhotos,
  }
}
